// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchemaGrid.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import commonFieldPropsSchema from 'modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartFieldPropsSchema';
import constants from 'logic/data/Izenda.ReportPartGridConstants';
import { get, getOr, reduce, rearg, unset, forEach } from 'lodash/fp';

const REMOVED_HEADER_FORMAT_FOR_PIVOT_COLUMN = [
  'fields.headerFormating.fields.fontFormat',
  'fields.headerFormating.fields.fontStyle',
  'fields.headerFormating.fields.alignment',
  'fields.headerFormating.fields.verticalAlignment',
  'fields.headerFormating.fields.columnGroup'
];

const REMOVED_COLUMN_GROUP = ['fields.headerFormating.fields.columnGroup'];

const REMOVED_HEADER_FORMAT_FOR_SEPARATOR = ['fields.headerFormating'];

const REMOVE_PROPERTY_BY_KEY = {
  hideConflitHeaderFormating: REMOVED_HEADER_FORMAT_FOR_PIVOT_COLUMN,
  hideColumnGroup: REMOVED_COLUMN_GROUP,
  hideAllHeaderFormating: REMOVED_HEADER_FORMAT_FOR_SEPARATOR
};

export default function(editorComp, reportDesignerModel, fieldStore, itemProps) {
  let gridFieldPropsSchema = commonFieldPropsSchema.apply(null, arguments);

  const container = itemProps.fieldContainerDetails;
  const configReportPart = reportDesignerModel.configReportPart;
  const reportPartContent = configReportPart.reportPartContent;
  let mappingSource = gridFieldPropsSchema.mappingSource;
  const forEachWithKey = forEach.convert({ cap: false });

  // add config to [subTotal]
  mappingSource.isHiddenSubTotal = function() {
    return get(
      [reportPartContent.gridStyle, getOr('', 'name', container), 'hideSubTotal'].join('.'),
      constants.FIELD_PROPERTY_CONFIG
    );
  };

  mappingSource.isSeparator = function() {
    return get('name', container) === constants.CONTAINER_NAME.SEPARATORS;
  };

  mappingSource.isVerticalHeaderHidden = function() {
    return get('name', container) !== constants.CONTAINER_NAME.COLUMNS || reportPartContent.gridStyle !== constants.GRID_STYLES.PIVOT.value;
  };

  function checkByKey(key) {
    return get(
      [reportPartContent.gridStyle, getOr('', 'name', container), key].join('.'),
      constants.FIELD_PROPERTY_CONFIG
    );
  }

  forEachWithKey(function(removeProperties, key) {
    if (checkByKey(key)) {
      gridFieldPropsSchema.definedSchema = reduce(
        rearg([1, 0], unset),
        gridFieldPropsSchema.definedSchema,
        removeProperties
      );
    }
  }, REMOVE_PROPERTY_BY_KEY);

  return gridFieldPropsSchema;
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.ReportPartFieldPropsSchemaGrid.js